/* One place decides where a company name points. */
export const recordHref = (linkType, linkId) => {
  if (!linkId) return null;
  const t = String(linkType || "").toLowerCase();
  if (t === "client") return `/clients/${encodeURIComponent(linkId)}`;
  if (t === "prospect") return `/prospects/${encodeURIComponent(linkId)}`;
  return null;
};
